import { Cell, MARKET_SLIDES, SlidesByType } from '../constants';

import { UpsellCell } from './types';

const SlidesPerMarket: UpsellCell = [Cell.ExampleMarketWithCountry].reduce(
  (res, cell) => ({
    ...res,
    [cell]: {
      [SlidesByType.DEFAULT]: MARKET_SLIDES,
    },
  }),
  {} as UpsellCell
);

export default SlidesPerMarket;
